// Подписи блоков решает сервер (с 10.10, гид §2.9 п.1): block_titles[экран][ключ] → block_titles.default[ключ] → своя строка.
// Экраны: match, match_analysis, home, team, player, venue, tournament, tournament_stats, records, search, favorites,
// rankings, leagues, highlights.
import { useCallback } from 'react';
import { useConfig } from './queries';
import type { AppConfig } from './types';

export function blockTitle(config: AppConfig | undefined, screen: string, key: string, fallback: string): string {
  return config?.block_titles?.[screen]?.[key] ?? config?.block_titles?.default?.[key] ?? fallback;
}

/** `title(key, своя)` для экрана `screen`. */
export function useBlockTitle(screen: string) {
  const config = useConfig().data;
  return useCallback((key: string, fallback: string) => blockTitle(config, screen, key, fallback), [config, screen]);
}
